import { ASSISTED_TRANSFER_SUBACTION } from '../../constants';
import SingletonWebSocket from '../Singletons/SingletonWebSocket';
export const STRATEGIES_ASSISTED_TRANSFER = {
    "MAIN_CALL" : (that) => {
        let integrationMessage = {client : "galatea", data : that.information[0].number , action : "AssistedTransfer", subaction : "onMainCall"};
        SingletonWebSocket.send(integrationMessage);
        that.sharedData.setAssistedTransferCurrentState(integrationMessage);
        that.information[0].active = true;
        that.information[1].active = false;
    },
    "ON_STATUS" : (that) => {
        let integrationMessage = {client : "galatea", data : that.information[1].number , action : "AssistedTransfer", subaction : "onSecondCall"};
        SingletonWebSocket.send(integrationMessage);
        that.sharedData.setAssistedTransferCurrentState(integrationMessage);
        that.information[0].active = false;
        that.information[1].active = true;
    },
    "CONFERENCE_CALL_CONNECTED" : (that) => {
        let integrationMessage = {client : "galatea", data : that.sharedData.getConferenceNewNumber(), action : "AssistedTransfer", subaction : "onNextCall"};
        SingletonWebSocket.send(integrationMessage);
        that.sharedData.setAssistedTransferCurrentState(integrationMessage);
        that.information.push({title :  that.language.getText("CallControlGUIAssistedCallTransfernewCall"), active : true, flag : "new", number : that.sharedData.getConferenceNewNumber(), callId:that.sharedData.getConferenceCallID()});
        that.sharedData.addCallConference();
        that.setState({newCallNumber:"",transferring: false});
        that.data.sPhone = ""
    },
    "CONFERENCE_CALL_HANG_UP": (that) => {
        const callIdToErase = that.sharedData.getConferenceHangUpOther();
        if(!that.state.transferring){
            that.sharedData.substractCallConference();
        }
        that.setState({transferring: false});
        that.information = that.information.filter(call => call.callId !== callIdToErase);
    },
    "NEW_SECOND_CALL_SET": (that) => {
        that.information.splice(1,1);
        that.sharedData.substractCallConference();
    },
    "ON_CONFERENCE": (that) => {
        that.setState({isInConference : true});
        that.information.map((item, i) => item.active = true);
        that.data.reference = "conference";
        const _that = that;
        setTimeout(() => {
             _that.props.messageAssistedTransferCall(ASSISTED_TRANSFER_SUBACTION.ASSISTED,that.data)
        },100);
        let integrationMessage = {client : "galatea", action : "AssistedTransfer", subaction : "onConference"};
        SingletonWebSocket.send(integrationMessage);
        that.sharedData.setAssistedTransferCurrentState(integrationMessage);
    },
    "ON_CONFERENCE_CALL": (that) => {
        that.setState({transferring: true});
        that.data.sPhone = that.state.newCallNumber;
        that.sharedData.setConferenceNewNumber(that.data.sPhone);
        that.data.reference = "next"
        that.data.callId = Math.floor((Math.random() * 10000));
        that.sharedData.setConferenceCallID(that.data.callId);
        const _that = that;
        setTimeout(() => {
             _that.props.messageAssistedTransferCall(ASSISTED_TRANSFER_SUBACTION.ASSISTED,that.data)
        },100);
    }

};



// WEBPACK FOOTER //
// ./src/js/Strategies/StrategiesAssistedTransfer.js